import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentItemComponent } from './payment-item.component';
import { AmountFormatModule, AmountFormatPipe, DateFormatModule, StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import { MyBookingItineraryService } from '@common/services/my-booking/my-booking-itinerary.service';
import { MilesFormatModule } from '@common/pipes/miles-format/miles-format.module';
import { PassengerNameModule } from '@common/pipes';

@NgModule({
  declarations: [PaymentItemComponent],
  imports: [
    CommonModule,
    StaticMsgModule,
    AmountFormatModule,
    DateFormatModule,
    MilesFormatModule,
    PassengerNameModule,
  ],
  exports: [PaymentItemComponent],
  providers: [MyBookingItineraryService, AmountFormatPipe, StaticMsgPipe],
})
export class PaymentItemModule {}
